export const SELECT_PARTS = [
  'clearIndicator',
  'control',
  'dropdownIndicator',
  'group',
  'groupHeading',
  'indicatorSeparator', // isn't linked to style yet
  'indicatorsContainer',
  'loadingMessage',
  'menu',
  'menuList',
  'multiValueContainer', // isn't linked to style yet
  'multiValueLabel',
  'multiValueRemove',
  'noOptionsMessage',
  'option',
  'optionSuggestionIcon',
  'placeholder',
  'selectContainer',
  'singleValue',
  'suggestionsAvailableIcon',
  'suggestionsRejectedIcon',
  'valueContainer',
] as const;
